<template>
    <div class="setting ">
        <div class="setting__label">{{$t(item.texts.Title)}}</div>
        <div class="setting__option tabs">
            <button type="button" 
                v-for="(options,index) in item.items" 
                :key="options.id" 
                :value="index" 
                class="tab-btn" 
                :class="{active : (item.selected === index)}" 
                @click.prevent="item.selected = index">
                    {{$t(options.name)}}
                </button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'input-tabs',
    props: ['item', 'index'],
    data() {
        return {
            title: null,
            prevIndex: null
        }
    },
    methods: {
        selectItem() {
            //this.tech.selected = !this.tech.selected;
            this.$emit('unit-clicked', this);
        }
    },
    mounted: function () {
        this.$nextTick(function () {
            //this.iTitle = (this.displayUnit) ? this.tech.type : this.tech.title;
        });
    }
}
</script>

<style lang="css" >

</style>


// WEBPACK FOOTER //
// input.tabs.vue?592d859e